import { nanoid } from 'nanoid';

export const generateRandomPassword = () => nanoid(8);
